<section class="reward-section" *ngIf="rewardsContent && rewardsContent?.rewardActive">
  <div class="box">
    <h2 id="rewardSection" class="sub-heading" [innerHTML]="rewardsContent?.heading | safeHtml"></h2>
    <div class="content">
      <div [innerHTML]="rewardsContent?.description | safeHtml"></div>
      <ng-container *ngIf="greenLighteningContent">
        <div class="flex-container green-lightening" [innerHTML]="greenLighteningContent | safeHtml"></div>
      </ng-container>
      <ng-container *ngIf="!greenLighteningContent">
        <div class="flex-container points-container">
            <div class="grid-container">
              <!-- COSTCO CONSUMER LAYOUT-->
              <ng-container *ngIf="rewardsContent?.layout =='vertical'">
                <div class="grid-item">
                  <div class="d-flex flex-column points-container"
                    style="justify-content: center; text-wrap: wrap;">
                    <div class="d-flex flex-row" style="align-self: anchor-center">
                      <div class="vertical-top">
                        <img class="horizontal-reward"
                          [cache]="imageBasePath+leftColData?.pointsContent?.pointFive?.iconPath"
                          [lazyload]="imageBasePath+leftColData?.pointsContent?.pointFive?.iconPath"
                          [alt]="leftColData?.pointsContent?.pointFive?.adaText"
                          style="border-color: #0033a0" />
                        <div [innerHtml]="leftColData?.pointsContent?.pointFive?.title | safeHtml"
                          style="text-align: center"></div>
                      </div>
                    </div>
                    <div class="text-center">
                      <div [innerHtml]="rewardsContent?.arrowText | safeHtml" ></div>
                    </div>
                    <div>
                      <div class="d-flex flex-row" style="align-items: baseline">
                        <div
                          style="width: 50%; padding-top: 1.25rem; padding-bottom: 1.25rem; padding-right: .625rem; justify-items: center; align-items: baseline">
                         <img class="horizontal-reward"
                            [cache]="imageBasePath+leftColData?.pointsContent?.pointFour?.iconPath"
                            [lazyload]="imageBasePath+leftColData?.pointsContent?.pointFour?.iconPath"
                            [alt]="leftColData?.pointsContent?.pointFour?.adaText"
                            style="border-color: #358640" />
                          <div class="vertical-title"
                            [innerHtml]="leftColData?.pointsContent?.pointFour?.title | safeHtml">
                          </div>
                        </div>
                        <div
                          style="width: 50%; padding-left: .625rem; align-content: end; justify-items: center; align-items: baseline">
                          <img class="horizontal-reward"
                            [cache]="imageBasePath+leftColData?.pointsContent?.pointThree?.iconPath"
                            [lazyload]="imageBasePath+leftColData?.pointsContent?.pointThree?.iconPath"
                            [alt]="leftColData?.pointsContent?.pointThree?.adaText"
                            style="border-color: #196ca7" />
                          <div class="vertical-title"
                            [innerHtml]="leftColData?.pointsContent?.pointThree?.title | safeHtml">
                          </div>
                        </div>
                      </div>
                      <div class="d-flex flex-row" style="align-items: baseline">
                        <div class="vertical-bottom-tier" style="padding-right: .625rem">
                          <img class="horizontal-reward"
                            [cache]="imageBasePath+leftColData?.pointsContent?.pointTwo?.iconPath"
                            [lazyload]="imageBasePath+leftColData?.pointsContent?.pointTwo?.iconPath"
                            [alt]="leftColData?.pointsContent?.Two?.adaText"
                            style="border-color: #c8102e" />
                          <div class="vertical-title"
                            [innerHtml]="leftColData?.pointsContent?.pointTwo?.title | safeHtml">
                          </div>

                        </div>
                        <div class="vertical-bottom-tier" style="padding-left: .6245rem; justify-items: center">
                          <img class="horizontal-reward"
                            [cache]="imageBasePath+leftColData?.pointsContent?.pointOne?.iconPath"
                            [lazyload]="imageBasePath+leftColData?.pointsContent?.pointOne?.iconPath"
                            [alt]="leftColData?.pointsContent?.pointOne?.adaText"
                            style="border-color: #58595b" />
                          <div class="vertical-title"
                            [innerHtml]="leftColData?.pointsContent?.pointOne?.title | safeHtml">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
              <!--COSTCO BUSINESS LAYOUT-->
              <ng-container *ngIf="rewardsContent?.layout =='horizontal'">
                <div class="grid-item">
                  <div class="d-flex flex-row flex-wrap flex-sm-nowrap justify-content-center align-items-start"
                    style="text-align: center">
                    <div class="d-flex flex-column" style="width: 100%">
                      <div class="d-flex align-items-stretch">
                        <div class="d-flex flex-column align-items-center mr-2" style="width: 50%; flex-grow: 1">
                          <div class="percentile-icon" style="padding-bottom: .625rem">
                            <img [cache]="imageBasePath+leftColData?.pointsContent?.pointFive?.iconPath"
                              [lazyload]="imageBasePath+leftColData?.pointsContent?.pointFive?.iconPath"
                              [alt]="leftColData?.pointsContent?.pointFive?.adaText" width="100" height="90" />
                          </div>
                          <div class="w-100 h-10" style="background-color: #0033a0;">&nbsp;</div>
                          <div class="inner-desc align-self-start h-100 mb-0"
                            [innerHtml]="leftColData?.pointsContent?.pointFive?.title | safeHtml"
                            style="border-left:1px solid"></div>
                        </div>
                        <div class="d-flex flex-column align-items-center" style="width: 50%; flex-grow: 1">
                          <div class="percentile-icon" style="padding-bottom: .625rem">
                            <img [cache]="imageBasePath+leftColData?.pointsContent?.pointFour?.iconPath"
                              [lazyload]="imageBasePath+leftColData?.pointsContent?.pointFour?.iconPath"
                              [alt]="leftColData?.pointsContent?.pointFour?.adaText" width="100" height="90" />
                          </div>
                          <div class="w-100 h-10" style="background-color: #358640;" aria-hidden="true">&nbsp;</div>
                          <div class="inner-desc h-100 mb-0"
                            [innerHtml]="leftColData?.pointsContent?.pointFour?.title | safeHtml"
                            style="border-right:1px solid"></div>
                        </div>
                      </div>
                      <div class="text-center points-desc" [innerHtml]="rewardsContent?.arrowText | safeHtml"></div>
                    </div>
                    <div class="d-flex flex-column align-items-center mx-2" style="width: 50%">
                      <div class="percentile-icon">
                        <img [cache]="imageBasePath+leftColData?.pointsContent?.pointThree?.iconPath"
                          [lazyload]="imageBasePath+leftColData?.pointsContent?.pointThree?.iconPath"
                          [alt]="leftColData?.pointsContent?.pointThree?.adaText" width="100" height="90" />
                      </div>
                      <div class="w-100 h-10" style="background-color: #196ca7;">&nbsp;</div>
                      <p class="inner-desc" [innerHtml]="leftColData?.pointsContent?.pointThree?.title | safeHtml"></p>
                    </div>
                    <div class="d-flex flex-column align-items-center mr-2" style="width: 50%">
                      <div class="percentile-icon">
                        <img [cache]="imageBasePath+leftColData?.pointsContent?.pointTwo?.iconPath"
                          [lazyload]="imageBasePath+leftColData?.pointsContent?.pointTwo?.iconPath"
                          [alt]="leftColData?.pointsContent?.pointTwo?.adaText" width="100" height="90" />
                      </div>
                      <div class="w-100 h-10" style="background-color: #c8102e;">&nbsp;</div>
                      <p class="inner-desc" [innerHtml]="leftColData?.pointsContent?.pointTwo?.title | safeHtml"></p>
                    </div>
                    <div class="d-flex flex-column align-items-center mr-2" style="width: 50%">
                      <div class="percentile-icon">
                        <img [cache]="imageBasePath+leftColData?.pointsContent?.pointOne?.iconPath"
                          [lazyload]="imageBasePath+leftColData?.pointsContent?.pointOne?.iconPath"
                          [alt]="leftColData?.pointsContent?.pointOne?.adaText" width="100" height="90" />
                      </div>
                      <div class="w-100 h-10" style="background-color: #58595b;">&nbsp;</div>
                      <p class="inner-desc" [innerHtml]="leftColData?.pointsContent?.pointOne?.title | safeHtml"></p>
                    </div>
                  </div>
                </div>
              </ng-container>

            <!-- ALL OTHER CARD LAYOUTS-->
            <ng-container *ngIf="rewardsContent?.layout != 'vertical' && rewardsContent?.layout != 'horizontal'">
              <div class="flex-item points-container" *ngIf="isPointTemplate else textTemplate"
                [ngClass]="getTemplateClass()">
                <div class='points-item' *ngFor="let reward of leftColData.pointsContent">
                  <div class="points-icon">
                    <img [src]="imageBasePath+reward?.iconPath" [alt]="reward?.adaText" role="presentation"
                      aria-hidden="true" />
                  </div>
                  <div class="points-text">
                    <span *ngIf="reward.adaText" class="sr-only" [innerHTML]="reward?.adaText+' '"></span>
                    <div [innerHTML]="reward?.title | adaFriendlyName: 'ignoreHtmlTags'| safeHtml"></div>
                  </div>
                </div>
              </div>
            </ng-container>

            <ng-template #textTemplate>
              <div class="flex-item text-container">
                <div *ngIf="leftColData?.textContent?.title" class="text-heading text-blue"
                  [innerHTML]="leftColData?.textContent?.title | adaFriendlyName: 'ignoreHtmlTags' | safeHtml">
                </div>
                <div *ngIf="leftColData?.textContent?.subTitle" class="text-subheading text-green"
                  [innerHTML]="leftColData?.textContent?.subTitle | adaFriendlyName: 'ignoreHtmlTags' | safeHtml">
                </div>
                <div *ngIf="leftColData?.textContent?.desc" class="text-description"
                  [innerHTML]="leftColData?.textContent?.desc | adaFriendlyName: 'ignoreHtmlTags' | safeHtml"></div>
              </div>
            </ng-template>

            <div class="grid-item">
              <div class="flex-item reward-feature"
                [ngStyle]="{'border-color': !!rewardsContent.borderColor ? rewardsContent.borderColor : 'inherit'}"
                [ngClass]="{'point-border': isPointTemplate, 'text-border': !isPointTemplate}"
                *ngIf="rightColData && rightColData?.content">
                <div class="reward-feature-item" *ngFor="let feature of rightColData?.content">
                  <div class="reward-feature-title" *ngIf="feature?.title"
                    [innerHTML]="feature?.title | adaFriendlyName: 'ignoreHtmlTags' | safeHtml"></div>
                  <div [innerHTML]="feature?.desc | adaFriendlyName: 'ignoreHtmlTags' | safeHtml"></div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </ng-container>
    <div class="spacer" role="presentation" aria-hidden="true"></div>
  </div>
  </div>
</section>
<style>
  .grid-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    .horizontal-reward{
      display: block;
      width: 230px;
      height: 100px;
    }
  }

  @media screen and (max-width: 1024px) {
    .grid-container {
      .horizontal-reward{
        width: 180px;
        height: 100px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .grid-container {
      grid-template-columns: 1fr;
      .horizontal-reward{
        width: 2.5rem;
        height: 2.5rem;
      }
    }
  }

  .grid-item {
    padding: 20px;
  }
</style>